import DrawerWrapper from "./DrawerWrapper";
import { useCart } from "../context/CartContext";

export default function CartDrawer({ open, close }) {
  const { cart, updateQty, removeFromCart } = useCart();

  return (
    <DrawerWrapper open={open} close={close}>
      <h2 className="text-xl font-bold mb-4 p-5">Your Cart</h2>

      {cart.length === 0 ? (
        <p className="text-gray-500 p-5">Your cart is empty.</p>
      ) : (
        <div className="space-y-4 p-5">
          {cart.map((item) => (
            <div
              key={item.id}
              className="flex gap-3 bg-white p-3 rounded shadow-sm"
            >
              <img
                src={item.image}
                alt={item.name}
                className="w-20 h-20 rounded object-cover"
              />

              <div className="flex-1">
                <h3 className="font-semibold text-sm">{item.name}</h3>

                <p className="text-gray-600 text-sm">
                  ₹{item.discountedPrice} × {item.qty} ={" "}
                  <span className="font-semibold">
                    ₹{item.discountedPrice * item.qty}
                  </span>
                </p>

                {/* Qty Buttons */}
                <div className="flex items-center gap-3 mt-2">
                  <button
                    onClick={() =>
                      updateQty(item.id, Math.max(1, item.qty - 1))
                    }
                    className="px-3 py-1 border text-lg rounded"
                  >
                    –
                  </button>

                  <span className="text-lg font-medium">{item.qty}</span>

                  <button
                    onClick={() => updateQty(item.id, item.qty + 1)}
                    className="px-3 py-1 border text-lg rounded"
                  >
                    +
                  </button>
                </div>

                {/* Remove Button */}
                <button
                  onClick={() => removeFromCart(item.id)}
                  className="text-red-600 text-sm mt-2 flex items-center gap-1"
                >
                  Remove 
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </DrawerWrapper>
  );
}
